<template>
  <section class="negocieApp">
    <header>
      <div>
        <router-link :to="{ name: 'negociejaApp' }" class="btVoltar" v-if="inner">
          <fa :icon="['far', 'arrow-left']" />
        </router-link>
      </div>
      <div>
        <logo size="40px" />
      </div>
    </header>
    <inner-page :state="inner" :session="session" :step="step" :steps="steps" :msg="msg">
      <negociar v-if="session == 'negociar'" :session="session" :step="step" :steps="steps" :debitos="debitos" />
    </inner-page>
    <main>
      <div class="intro">
        <h3>Olá Fernando</h3>
        <p>Seja bem vindo ao <b>Negocie Já</b>.<br/>Aqui você quitar seus débitos com a Rede Decisão<br>de forma rápida e sem complicação.</p>  
      </div>
      <home-banner :pendencias="pendencias" :step="step"/>
      <home-dash />
    </main>
    <nav-menu />
  </section>
</template>

<script>
import Logo from '@/components/template/logo.vue'
import HomeDash from '@/components/financeiro/negocieja/app/utilities/HomeDash.vue'
import NavMenu from '@/components/financeiro/negocieja/app/navigation/NavMenu.vue'
import HomeBanner from '@/components/financeiro/negocieja/app/utilities/HomeBanner.vue'
import InnerPage from '@/components/financeiro/negocieja/app/template/InnerPage.vue'
import Negociar from '@/components/financeiro/negocieja/app/template/Negociar.vue'
import FinanceiroService from '@/services/financeiro.service.js'
import NegociaService from '@/services/negocieja.service.js'

export default {
  components: {
    Logo, HomeDash, NavMenu, HomeBanner, InnerPage, Negociar
  },
  props: {
    session: {
      type: String
    },
    step: {
      type: String
    }
  },
  watch: {
    session ( value ) {
      if ( value ) {
        this.inner = true
      } else {
        this.inner = false
      }
    }
  },
  data () {
    return {
      currentUser: localStorage.getItem('profile') ? JSON.parse(atob(localStorage.getItem('profile'))) : null,
      range: {
        inicio: '2022-01-01',
        fim: '2025-12-01',
      },
      pendencias: false,
      inner: false,
      current: 0,
      msg: null,
      loading: true,
      debitos: null,
      steps: [
         {
          slug: 'debitos',
          title: 'Débitos'  
        },
        {
          slug: 'pagamento',
          title: 'Pagamento'  
        },
        {
          slug: 'parcelas',
          title: 'Parcelas'  
        },
        {
          slug: 'checkout',
          title: 'Checkout'  
        },
        {
          slug: 'termo',
          title: 'Termo'  
        }
      ]
    }
  },
  mounted () {
    if ( this.session ) {
      this.inner = true
    } else {
      this.inner = false
      this.getFicha()
    }
  },
  methods: {
    dropMessage ( value ) {
      this.msg = value
      // console.log("dropMessage:", value)
    },
    getFicha () {
      const idPessoa = 564966
      // const idPessoa = this.currentUser.idPessoa
      console.log("idPessoa:", this.currentUser)
      
      const options = {
        idPessoa: idPessoa,
        ...this.range
      }

      FinanceiroService.getFichaFinanceira(options).then(
        response => {
          if ( response.data.length > 0 ) {
            this.parseData(response.data)
          }
        },
        error => {
          console.error(error)
          window.spinner.emit('close')
        }
      )
    },
    parseData ( data ) {
      const atrasados = data.filter( a => a.situacao == 'Atrasado' )

      const mencodigos = atrasados.map( k => k.mencodigo )
      console.log('mencodigos:', mencodigos)
      this.pendencias = mencodigos.length > 0
      console.log('pendencias:', this.pendencias)

      if ( this.pendencias ) {
        this.calculaDebitos(mencodigos, mencodigos)
      }
      
    },
    calculaDebitos ( debitos, mencodigos ) {
      const data = {
        // cpf_responsavel_financeiro: this.currentUser.cadastro.Documento.cpf,
        cpf_responsavel_financeiro: 41729109802,
        mencodigos: debitos
      }
      NegociaService.getDebitos( data ).then(response => {
        // console.log('getDebitos:', response.data)
        const debitos = response.data
        const mensalidadesMatriculas = debitos.mensalidadesMatriculas

        const uniqueMatcodigos = [...new Set(mensalidadesMatriculas.map(item => item.matcodigo))]
        const totalMatriculas = uniqueMatcodigos.length
        
        const msgContent = {
          totalMatriculas,
          totalMensalidades: mensalidadesMatriculas.length
        }
        this.createMsg(msgContent)

        this.debitos = {
          ...debitos,
          mencodigos
        }
      }).catch( error => {
        console.error(error)
      })
    },
    createMsg ( options ) {
      const { totalMensalidades, totalMatriculas } = options
      this.msg = `${totalMensalidades} parcela${totalMensalidades > 1 ? 's' : ''} em aberto, em ${totalMatriculas} matrícula${totalMatriculas > 1 ? 's diferentes' : ''}.`
    }
  }
}
</script>

<style lang="scss" scoped>
  .negocieApp {
    display: block;
    width: 100%; height: 100vh;
    // overflow-y: auto;
    overflow: hidden;
    background-image: 
      url('@/assets/img/app_negocie_bg.png'),
      radial-gradient(circle at top left, #6b70ec, #666be9, #6266e6, #5d61e3, #585ce0, #5557de, #5353db, #504ed9, #4f48d7, #4f42d4, #4e3cd2, #4e35cf);
    background-repeat: no-repeat, no-repeat;
    background-position: top right, top left;
    background-size: auto, cover;
    color: $color-secondary;
    max-width: 1024px;
    margin: auto;
    box-shadow: -3px 3px 24px rgba(79, 84, 219, 0.5);
    position: relative;

    @media screen and ( min-width: 1024px ) {
      border-radius: $border-radius-large;
      max-height: calc(100vh - 60px);
      margin-top: 30px;
    }
    > header {
      display: flex; width: 100%;
      padding: $hmg_large;
      position: relative;
      z-index: 102;

      .btVoltar {
        width: 40px; height: 40px;
        border: 2px solid $color-secondary;
        font-size: 18px;
        display: flex; flex-direction: column;
        align-items: center; justify-content: center;
        line-height: 1;
        border-radius: 16px;
        color: $azul-escuro;
        background-color: #F4F6FB;
      }

      >div {
        flex: 1;

        &:last-child {
          display: flex; justify-content: flex-end;
        }
      }
    }

    main {
      padding: 0 $hmg_large $hmg_large;

      .intro {
        padding: $hmg_mid;
      }
    }
  }
</style>